import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";

export default function Login() {

  const navigate = useNavigate();

  const [email,setEmail]=useState("");

  const [password,setPassword]=useState("");

  const [loading,setLoading]=useState(false);

  async function handleLogin(e){

    e.preventDefault();

    setLoading(true);

    const {error}=await supabase.auth.signInWithPassword({

      email,

      password

    });

    setLoading(false);

    if(error){

      alert(error.message);

      return;

    }

    navigate("/admin/dashboard");

  }

  return(

<div className="min-h-screen bg-slate-100 flex items-center justify-center">

<form

onSubmit={handleLogin}

className="bg-white shadow-xl rounded-xl p-10 w-[420px]"

>

<h1 className="text-3xl font-bold text-center text-blue-900">

SURBANCO

</h1>

<p className="text-center text-gray-500 mb-8">

Banking CMS Login

</p>

<input

type="email"

placeholder="Email"

className="border p-3 w-full mb-4 rounded"

value={email}

onChange={(e)=>setEmail(e.target.value)}

/>

<input

type="password"

placeholder="Password"

className="border p-3 w-full mb-6 rounded"

value={password}

onChange={(e)=>setPassword(e.target.value)}

/>

<button

className="bg-blue-900 text-white w-full py-3 rounded"

disabled={loading}

>

{loading ? "Signing In..." : "Login"}

</button>

</form>

</div>

);

}